import { Route } from 'react-router';
import RequireAuth from '../../guards/RequireAuth';
import MainLayout from '../../layouts/MainLayout';
import Show from './Show';

const Routes = (
  <Route
    path="/settings/paper"
    element={
      <RequireAuth>
        <MainLayout />
      </RequireAuth>
    }
  >
    <Route path="/settings/paper" element={<Show />} />
  </Route>
);

export default Routes;
